<template>
  <DashboardLayout>
    <router-view
      v-slot="{ Component }"
    >
      <Suspense>
        <div
          class="h-full min-h-full max-w-7xl"
        >
          <keep-alive :exclude="excludedRoutes">
            <component
              :is="Component"
              :key="route.path"
            />
          </keep-alive>
        </div>
      </Suspense>
    </router-view>
  </DashboardLayout>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { marketing } from '@/services/tracking';
import DashboardLayout from './components/layout.vue';

const route = useRoute();
const excludedRoutes = ref(['nmiForm']);

watch(() => route.path, () => {
  marketing.track('dashboard_loaded');
}, { immediate: true });
</script>
